export default "__VITE_ASSET__BX7roOLJ__"